export default "__VITE_ASSET__DmM8f5IZ__"